import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { MeasurementSettingsParams, MeasurementSettings, MeasurementSettingsResponse } from '../types';
import { transformMeasurementSettingsResponse } from '../utils/response-transformers';

export function* fetchMeasurementSettings(params: MeasurementSettingsParams, options?: ApiRequestConfig) {
  const data = (yield* get<MeasurementSettings>(
    'get-checkout-settings',
    {
      productId: params.productId,
      regionCode: params.regionCode,
      modelId: params.modelId,
      unitOfsale: params.unitOfsale,
    },
    {
      ...options,
    },
  )) as unknown;

  return transformMeasurementSettingsResponse(data as MeasurementSettingsResponse);
}
